import {defineMessages} from 'react-intl'
import R from 'ramda'

import likeEstate from '../api/likeEstate'

import toggleLoginRequiredModal from './toggleLoginRequiredModal'
import addNotification from './addNotification'

const messages = defineMessages({
  title: {
    id: "Your like can't be saved", 
    defaultMessage: "Your like can't be saved"
  },
  message: {
    id: "Something bad happened, and your like can't be saved", 
    defaultMessage: "Something bad happened, and your like can't be saved"
  }
})

const notification = {type: "error", message: messages.message, title: messages.title}

const onComplete = dispatch => (err, resp) => {
  if(err) {
    dispatch({type: 'like_estate', estateId, like: !newLike})
    dispatch(addNotification(notification))
    return console.error('Failed to like an estate', err)
  }
}

export default (estateId, newLike) => (dispatch, getState) => {
  const token = R.path(['session', 'token'], getState())
  const userName = R.path(['session', 'userName'], getState())
    
  if(!userName || !token){
    dispatch(toggleLoginRequiredModal())
      return 
  }
  dispatch({type:'like_estate', estateId, like: newLike})
  likeEstate(userName, token, estateId, newLike, onComplete(dispatch))
}



/** WEBPACK FOOTER **
 ** ./app/actions/toggleEstateLike.js
 **/